module.exports = __webpack_public_path__ + "static/media/prospectus.b2ba04ab.pdf";